// src/metaPixel.js
export const initMetaPixel = () => {
  const pixelId = process.env.REACT_APP_FB_PIXEL_ID;
  const appEnv = process.env.REACT_APP_ENV;

  // Kör bara i production eller staging — och bara om pixelId finns
  if (!pixelId) return;
  if (appEnv !== "production" && appEnv !== "staging") return;

  // Undvik dubbelinit
  if (window.fbq) return;

  // ---- Meta Pixel bootstrap ----
  (function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = "https://connect.facebook.net/en_US/fbevents.js";
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script");

  // Initiera Pixel
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
};
